export const getDefaultState = () => {
  return {
    selectedLevel: null,
    selectedSection: null,
    selectedRow: null,
    selectedSeat: null
  };
};

// initial state
const state = getDefaultState();

const getters = {
  getSelectedLevel(state, getters, rootState, rootGetters) {
    const levels = rootGetters["level/getLevelsList"];
    if (state.selectedLevel && levels) {
      return levels.find(item => `${item.id}` === `${state.selectedLevel}`) || {};
    }
    return {};
  },
  getSelectedSection(state, getters, rootState, rootGetters) {
    const sections = rootGetters["level/getSectionsList"];
    if (state.selectedSection && sections) {
      return sections.find(item => `${item.id}` === `${state.selectedSection}`) || {};
    }
    return {};
  },
  getSelectedRow(state, getters) {
    const rows = getters.getSelectedSection.rows;
    if (state.selectedRow && rows) {
      return rows.find(item => `${item.id}` === `${state.selectedRow}`) || {};
    }
    return {};
  },
  getSelectedSeat(state, getters) {
    const seats = getters.getSelectedRow.seats;
    if (state.selectedSeat && seats) {
      return seats.find(item => `${item.id}` === `${state.selectedSeat}`) || {};
    }
    return {};
  },
  matchesCurrentSeatSelection(state, getters, rootState, rootGetters) {
    const venueId = rootGetters["venue/getActiveVenue"];
    const { selectedLevel: levelId, selectedSection: sectionId, selectedRow: rowId, selectedSeat: seatId } = state;
    const currentSelection = { venueId, levelId, sectionId, rowId, seatId };

    return JSON.stringify(currentSelection) === JSON.stringify(rootGetters["level/getCurrentSelection"]);
  }
};

// actions
const actions = {};

// mutations
const mutations = {
  setSelectedLevel(state, payload) {
    state.selectedLevel = payload.levelId;
  },
  setSelectedSection(state, payload) {
    state.selectedSection = payload.sectionId;
  },
  setSelectedRow(state, payload) {
    state.selectedRow = payload.rowId;
  },
  setSelectedSeat(state, payload) {
    state.selectedSeat = payload.seatId;
  },
  setSeatSelection(state, payload) {
    state.selectedLevel = payload.levelId;
    state.selectedSection = payload.sectionId;
    state.selectedRow = payload.rowId;
    state.selectedSeat = payload.seatId;
  },
  resetSeatSelection(state) {
    state.selectedLevel = null;
    state.selectedSection = null;
    state.selectedRow = null;
    state.selectedSeat = null;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
